
<template>
    <div
        class="text-input"
        @click="clickHandle"
        :class="{'validate-error':!validateResult,'readonly':readonly,'has-arrow':hasArrow,invisible:invisible}"
    >
        <div v-if="readonly || invisible" class="readonly-text">{{value}}</div>
        <div v-else class="input">
            <input
                :name="field"
                v-model.lazy="value"
                @focus="focusHandle"
                @keydown="keydownHandle"
                @keyup="keyupHandle"
                @input="inputHandle"
                ref="input"
            />
            <div class="switch" v-if="hasArrow" @mousedown.stop>
                <div class="up" @click.stop="changeValue(value,1)"></div>
                <div class="down" @click.stop="changeValue(value,-1)"></div>
            </div>
            <div class="validate-error-icon" v-if="!validateResult" @click.stop>
                <info-image @mouseenter.stop="errorIconMouseenter" @mouseleave="errorIconMouseleave"></info-image>
            </div>
        </div>
    </div>
</template>
<script>
import Gikam from "../../../core/gikam-core";
import BaseField from "../baseField/baseField.vue";
import infoImage from "../img/info.vue";

export default {
    name: "textInput",
    props: ["options", "propValue", "rowIndex", "cellIndex", "propReadonly","propInvisible"],
    extends: BaseField,
    components: { infoImage },

    data() {
        return {
            validateResult: true,
            field: this.options.field,
            value: this.propValue,
            hasArrow: this.options.hasArrow,
            readonly: Gikam.isNotEmpty(this.propReadonly)
                ? this.propReadonly
                : this.options.readonly,
            invisible: this.propInvisible
        };
    },

    computed:{
        isInteger() {
            return Gikam.isEmpty(this.options.isInteger) ? false : this.options.isInteger;
        },

        notRange() {
            return Gikam.isEmpty(this.options.range);
        },

        returnRangeArray() { 
            return this.options.range.slice(1,this.options.range.length-1).split(',');
        },

        returnRangeDelimit() { 
            return [this.options.range.slice(0,1), this.options.range.slice(this.options.range.length-1,this.options.range.length)]
        }
    },

    watch: {
        value(val) {
            if (val !== '' && typeof val === 'string') {
                this.value = isNaN(this.convertValue(val)) ? '' : this.convertValue(val);
            } else if (this.notRange) {
                this.$emit(
                    "change",
                    this.options.field,
                    val,
                    this.rowIndex
                );
            } else {
                this.checkValueFromRange(val);
            }
        },

        propValue(val) {
            this.value = val;
        },

        propInvisible(val) {
            this.invisible = val;
        }
    },

    methods: {
        checkValueFromRange(value) {
            if (this.notRange) {
                return 
            }
            const _v = this.convertValue(value);
            const leftNum = this.convertValue(this.returnRangeArray[0]);
            const rightNum = this.convertValue(this.returnRangeArray[1]);
            const leftDelimit = this.returnRangeDelimit[0];
            const rightDelimit = this.returnRangeDelimit[1];
            
            if (leftDelimit === '(' && _v <= leftNum) {
                this.value = leftNum + 1;
            } else if (leftDelimit === '[' && _v < leftNum) {
                this.value = leftNum;
            } else if (rightDelimit === ')' && _v >= rightNum) {
                this.value = rightNum - 1;
            } else if (rightDelimit === ']' && _v > rightNum) {
                this.value = rightNum;
            } else {
                this.$emit(
                    "change",
                    this.options.field,
                    value,
                    this.rowIndex
                );
            }
        },

        focusHandle() {
            this.validateResult = true;
            this.$emit("focus", this.options.field, this.value, this.rowIndex);
        },

        keydownHandle(e) {
            const ignoreKey = {
                8: "backspace",
                46: "delete",
                37: "leftArrow",
                39: "rightArrow",
                13: "enter"
            };
            if (
                !Gikam.isNumber(e.target.value + e.key) &&
                !ignoreKey[e.keyCode]
            ) {
                e.preventDefault();
                e.stopPropagation();
            }
        },

        keyupHandle(e) {
            this.$emit("keyup", e);
        },

        inputHandle(e) {
            this.$emit("input", e);
        },

        focus() {
            this.$refs.input.focus();
        },

        errorIconMouseenter(event) {
            this.showErrorPanel(event);
        },

        errorIconMouseleave(event) {
            this.removeErrorPanel(event);
        },

        changeValue(value, number) {
            const _v = isNaN( this.convertValue(value) ) ? 0 : this.convertValue(value) + number;
            this.value = _v < 0 ? 0 : _v;
        },

        clickHandle() {
            this.$emit("click", this);
        },

        convertValue(value) {
            return this.isInteger ?  parseInt(value) : parseFloat(value);
        }
    }
};
</script>

<style>
/* 通用样式 */
.text-input {
    width: 100%;
    height: 100%;
    padding: 0;
    display: flex;
    align-items: stretch;
}

.text-input.has-arrow input,
.text-input.readonly .readonly-text {
    width: 100%;
    height: 100%;
    padding-left: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
}

.text-input input:focus {
    border: 1px solid rgba(0, 122, 255, 0.5);
}

/* 只读样式 */
.text-input.readonly {
    align-items: center;
}

.text-input.readonly .readonly-text {
    color: #666;
}

/* 检验错误时样式 */
.text-input.validate-error input {
    border-color: #ff6e6e;
    padding-right: 25px;
}

.text-input.validate-error .validate-error-icon {
    margin-left: -25px;
    display: flex;
    align-items: center;
}

.text-input.validate-error .validate-error-icon svg {
    height: 20px;
    cursor: pointer;
}

.text-input .input{
    display: flex;
    width: 100%;
}
/* 有箭头时样式 */
.text-input.has-arrow input {
    padding-right: 25px;
}

.text-input.has-arrow .switch {
    display: inline-block;
    width: 25px;
    height: calc(100% - 2px);
    margin-top: 1px;
    margin-left: -26px;
    border-radius: 0 4px 4px 0 / 0 4px 4px 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.text-input.has-arrow .switch .up {
    flex-direction: column;
    background: url(../../../../img/date/up.png) no-repeat center;
    flex: 1;
    background-color: #d6d6d6;
    margin-top: -0.5px;
    cursor: pointer;
}

.text-input.has-arrow .switch .down {
    flex-direction: column;
    background: url(../../../../img/date/down.png) no-repeat center;
    flex: 1;
    background-color: #d6d6d6;
    border-top: 1px solid #fff;
    margin-bottom: -1px;
    cursor: pointer;
}

/* 数字框校验错误时样式 */
.text-input.has-arrow.validate-error input {
    padding-right: 50px;
}

.text-input.has-arrow.validate-error .validate-error-icon {
    margin-left: -50px;
}

.text-input.invisible .readonly-text {
    background-color: transparent;
    border: none;
}
</style>
